import * as types from './types';
import * as Selector from './selectors';

export const toggleDisplay = () => (dispatch: any, getState: any) =>
    dispatch({ type: types.TOGGLE_DISPLAY, payload: !Selector.getBrowserDisplayToggled(getState()) });

export const displayHTML = (html: string, consoleOutput: string) => (dispatch: any, getState: any) =>
    dispatch({ type: types.DISPLAY_HTML, html: html, console: consoleOutput });

export const clearBrowser = () => (dispatch: any) => dispatch({ type: types.CLEAR_BROWSER });